import { useState } from "react";
import GeneralInfoTab from "./GeneralInfoTab";
import ActivityHistoryTab from "./ActivityHistoryTab";
import EmailHistoryTab from "./EmailHistoryTab";

const ContactTabs = ({ selectedContact }) => {
  const [activeTab, setActiveTab] = useState("general");
  const renderTab = () => {
  switch (activeTab) {
    case "general":
      return <GeneralInfoTab selectedContact={selectedContact} />;

    case "activity":
      return <ActivityHistoryTab selectedContact={selectedContact} />;

    case "email":
      return <EmailHistoryTab selectedContact={selectedContact} />;

    default:
      return null;
  }
};

  const getClass = (tab) =>
    activeTab === tab ? "active" : "";

  return (
    <>
      <ul className="nav nav-tabs" role="tablist">
        <li
          role="presentation"
          className={getClass("general")}
        >
          <a onClick={() => setActiveTab("general")}>
            General Info
          </a>
        </li>

        <li
          role="presentation"
          className={getClass("activity")}
        >
          <a onClick={() => setActiveTab("activity")}>
            Activity History
          </a>
        </li>

        <li
          role="presentation"
          className={getClass("email")}
        >
          <a onClick={() => setActiveTab("email")}>
            Email History
          </a>
        </li>
      </ul>

      <div className="tab-content">
        {renderTab()}
      </div>
    </>
  );
};

export default ContactTabs;